import {
  AppGlobalsState,
  AppGlobalsActionTypes,
  SET_LOADING,
  SET_ERROR,
} from './types';

const initState: AppGlobalsState = {
  isLoading: false,
  message: '',
  hasError: false,
  errorMessage: '',
};

export const appGlobals = (
  state = initState,
  action: AppGlobalsActionTypes
): AppGlobalsState => {
  const { type } = action;
  switch (type) {
    case SET_LOADING:
      return { ...state, isLoading: action.isLoading, message: action.message };
    case SET_ERROR:
      return {
        ...state,
        hasError: action.hasError,
        errorMessage: action.errorMessage,
      };
    default:
      return state;
  }
};
